// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_22FIJ","visuallyhidden":"_2_eku","hide-text":"_1CiEB","center":"_2xUSI","noprint":"_3jO-s","tags":"p4A9B"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-tags/styles/default.scss
 ** module id = 1021
 ** module chunks = 2
 **/